import React from 'react';
import { connectCurrentRefinements } from 'react-instantsearch-dom';
import cx from 'classnames';

export const ClearFilter = connectCurrentRefinements(({ items, refine }) => {
  return (
    <div
      onClick={() => refine(items)}
      className={cx(
        'flex-shrink-0 ml-4 text-50 hover:text-smurfs-gold cursor-pointer',
        items.length > 0 && 'text-smurfs-gold'
      )}
    >
      Clear All
    </div>
  );
});
